'use client';

import { useMutation } from '@tanstack/react-query';

import { JWT_STORAGE_KEY } from 'src/utils/constants';

import { restClient } from 'src/lib/api';

export const useChangeLanguagePref = () => {
  const mutationFn = (payload) =>
    restClient
      .post('updateDefaultLang', payload, {
        headers: {
          token: sessionStorage.getItem(JWT_STORAGE_KEY),
        },
      })
      .then((res) => res?.data);
  return useMutation({
    mutationFn,
  });
};
